module.exports = __webpack_public_path__ + "static/cabify@2x-41442eacccf4f94dcff4b536bdc56e99.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/customer-stories/cabify@2x.jpg
// module id = 865
// module chunks = 33019919093843 122353984331245